//Modulos
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './auth10/components/forgot-password/forgot-password.component';
import { IndexComponent } from './auth10/components/index/index.component';
import { LogOutComponent } from './auth10/components/log-out/log-out.component';
import { SignInComponent } from './auth10/components/sign-in/sign-in.component';
import { SignUpUserComponent } from './auth10/components/sign-up-user/sign-up-user.component';
import { SignUpComponent } from './auth10/components/sign-up/sign-up.component';
import { VerifyEmailComponent } from './auth10/components/verify-email/verify-email.component';
import { VerifySmsComponent } from './auth10/components/verify-sms/verify-sms.component';


import { NopagefoundComponent } from './paginas/nopagefound/nopagefound.component';



const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  

{
  path: '',
  
  
          children: [
          {   
              path: 'dashboard',
             loadChildren: ()=> import ('./paginas/paginas.module').then(m => m.PaginasModule)
            
          },
         

          ]		
},
//Rutas auth10

{ path: 'sign-in', component: SignInComponent},
{ path: 'register', component: SignUpComponent },
{ path: 'sign-in-user', component: SignUpUserComponent },
{ path: 'forgot-password', component: ForgotPasswordComponent },
{ path: 'verify-email', component: VerifyEmailComponent },
{ path: 'log-out', component: LogOutComponent },
{ path: 'index', component: IndexComponent },
{ path: 'verify-sms', component: VerifySmsComponent },
{ path: '', pathMatch: 'full', redirectTo: 'sign-in'},
{ path: '**', component: NopagefoundComponent }
 
         

]


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }